export default __webpack_public_path__ + "static/media/bootstrap.054efa3f.png";